import api from '../../../services/api';

export const createPost = (payload) => api.post('/smm/posts', payload).then(r => r.data);
export const listPosts = (params) => api.get('/smm/posts', { params }).then(r => r.data);
export const updatePost = (id, payload) => api.patch(`/smm/posts/${id}`, payload).then(r => r.data);
export const publishNow = (id) => api.post(`/smm/posts/${id}/publish-now`).then(r => r.data);
